import { render } from "./HomePage.page.vue?vue&type=template&id=3ea3b892"
import script from "./HomePage.page.vue?vue&type=script&lang=js"
export * from "./HomePage.page.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/homePage/HomePage.page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ea3b892"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ea3b892', __exports__)) {
    console.log('reload')
    api.reload('3ea3b892', __exports__)
  }
  
  module.hot.accept("./HomePage.page.vue?vue&type=template&id=3ea3b892", () => {
    console.log('re-render')
    api.rerender('3ea3b892', render)
  })

}


export default __exports__